import React, { useEffect, useState, useRef } from "react";
import axios from "../../../common/interceptor";
import axios_noheader from "../../../common/interceptor_noheader";
import sentryError from "../../../common/sentryError";
import moengage from "../../../common/moengage";

import "./UserProfile.css";
import HelmetComponent from "../../../common/HelmetComponent.component";
import userProfileData from "../mock/UserProfileData.mock";
import loadScript from "./SearchLocationInput";
import Snackbar from "../../../common/SnackBarMessage";
import BrowserUtils from "../../user/astrologer/components/UAScripts";

import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import Moment from "moment";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import QueryString from "../../../common/util/QueryString";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const regExpSpecial = /^[a-zA-Z ]*$/;

const UserProfile = (props) => {
  const hiddenFileInput = useRef(null);
  const [snackBar, setSnackBar] = useState({
    open: false,
    message: "Error occurred, Please try again",
  });
  const [details, setDetails] = useState({
    name: "",
    relation: "",
    gender: "",
    email: "",
    phone: "",
    horoscopeStyle: "",
    dateOfBirth: "",
    placeOfBirth: "",
    timeOfBirth: "",
    profileUrl: "",
    lat: "",
    long: "",
    country: "",
  });

  const isInRegisterFlow = window.location.search.indexOf("register") >= 0;

  const [pageType, setPageType] = useState("");
  const [tempDate, setDate] = useState("");
  const [time, setTime] = useState(null);
  const [submitUrl, setSubmitURL] = useState("");
  const [image, setImage] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [placesScriptLoaded, setPlacesScriptLoaded] = useState(false);
  const [counter, setCounter] = useState(1);
  const [DOBOpen, setDOBOpen] = useState(false);
  const [TOBOpen, setTOBOpen] = useState(false);

  const showError = (message) => {
    setSnackBar({
      open: true,
      message: message,
    });
  };

  const closeError = () => {
    setSnackBar({
      open: false,
    });
  };

  const onNumValidate = (e) => {
    var validChars = userProfileData.validChars;
    if (!validChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const onDateEdit = (e, value) => {
    if (value && value.length > 0) {
      let temp = value.split("/");
      setDetails({ ...details, dateOfBirth: temp[1] + "/" + temp[0] + "/" + temp[2] });
      setDate(value);
    } else setDate("");
  };

  const onTimeEdit = (e, date) => {
    if (date !== null) {
      setTime(e);
      setDetails({ ...details, timeOfBirth: date });
    }
  };

  const onInputEdit = (e) => {
    switch (e.target.id) {
      case "nameInput":
        setDetails({ ...details, name: e.target.value });
        break;
      case "relationInput":
        setDetails({ ...details, relation: e.target.value });
        break;
      case "mobInput":
        setDetails({ ...details, phone: e.target.value });
        break;
      case "emailInput":
        setDetails({ ...details, email: e.target.value.replaceAll(/\s/g, "") });
        break;
      case "bgImageUpload":
        let file = e.target.files[0];
        setImage(file);
        let tempUrl = "";
        try {
          tempUrl = URL.createObjectURL(file);
        } catch (error) {
          tempUrl = "";
        }
        setDetails({ ...details, profileUrl: tempUrl });
        break;
      default:
    }
  };

  const validateEmail = (email) => {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test(email);
  };

  const onSubmitUserDetails = () => {
    if (details.name === "" || !details.name) {
      showError("Please enter your Name");
      return;
    } else if (!regExpSpecial.test(details.name)) {
      showError("Name can't contain special characters.");
      return;
    } else if (pageType === "childProfile" && (details.relation === "" || !details.relation)) {
      showError("Please enter your relation.");
      return;
    } else if (pageType === "childProfile" && !regExpSpecial.test(details.relation)) {
      showError("Relation can't contain special characters.");
      return;
    } else if (pageType === "childProfile" && details.phone && details.phone.length < 10) {
      showError("Mobile number must be 10 characters long.");
      return;
    } else if (details.gender === "" || !details.gender) {
      showError("Please select a gender.");
      return;
    } else if (details.dateOfBirth === "" || !details.dateOfBirth) {
      showError("Please enter date of birth.");
      return;
    } else if (details.timeOfBirth === "" || !details.timeOfBirth) {
      showError("Please enter time of birth.");
      return;
    } else if (
      query !== "Test POB" &&
      (query === "" || !query || (
        ((details?.lat || "") === "" || (details?.long || "") === "") &&
        ((details?.lat_dir || "") === "" || (details?.long_dir || "") === "")
      ))
    ) {
      showError("Please enter place of birth.");
      return;
    } else if (details.horoscopeStyle === "" || !details.horoscopeStyle) {
      showError("Please select a horoscope style.");
      return;
    } else if (pageType === "userProfile" && !validateEmail(details.email)) {
      showError("Please enter a valid email.");
      return;
    } else {
      setLoading(true);
      let file = image;
      if (file) {
        // For cases where user selects a file using explorer
        let fileName = file.name;
        let fileType = file.type;
        let allowedExtensions = [
          "image/jpg",
          "image/png",
          "image/jpeg",
          "image/webp",
          "image/JPG",
          "image/PNG",
          "image/JPEG",
          "image/WEBP",
        ];

        if (!allowedExtensions.includes(file.type)) {
          showError("Invalid file type. Please use jpg/ping/webp formats.");
        }
        if (file.size > 4e6) {
          showError("File size must be less than 4 MB.");
        }

        axios()
          .post("/user/upload-access", {
            fileName: fileName,
            fileType: fileType,
          })
          .then((response) => {
            let accessUrl = response.data.access_url;
            let signedRequest = response.data.url;
            let options = {
              headers: {
                "Content-Type": fileType,
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, PATCH, OPTIONS",
                "Access-Control-Allow-Headers": "X-Requested-With, content-type, Authorization",
              },
            };

            axios_noheader()
              .put(signedRequest, file, options)
              .then(async (result) => {
                sendData(accessUrl);
              })
              .catch((error) => {
                sentryError("USER_PROFILE_IMAGE_UPLOAD", error);
                showError("Something went wrong. please try again");
                setLoading(false);
              });
          })
          .catch((err) => {
            sentryError("USER_PROFILE_SUBMIT", err);
            showError("Something went wrong. please try again");
            setLoading(false);
          });
      } else {
        //For cases where user submits without opening explorer
        sendData();
      }
    }
  };

  const sendData = (data) => {
    const postData = {
      name: details.name,
      relation: details.relation,
      gender: details.gender,
      email: details.email,
      phone: details.phone,
      horoscopeStyle: details.horoscopeStyle,
      dateOfBirth: tempDate,
      placeOfBirth: query,
      timeOfBirth: details.timeOfBirth,
      profileUrl: data ? data : details.profileUrl ? details.profileUrl : "",
      country: details.country,
    }
    if (details?.lat || details?.long) {
      postData.lat = details.lat;
      postData.long = details.long;
    }
    if (details?.lat_dir) {
      postData.lat_deg = details.lat_deg;
      postData.lat_min = details.lat_min;
      postData.lat_dir = details.lat_dir;
      postData.long_deg = details.long_deg;
      postData.long_min = details.long_min;
      postData.long_dir = details.long_dir;
    }
    if (details?.time_zone) {
      postData.timeCorrectionValue = details.timeCorrectionValue;
      postData.timeCorrection = details.timeCorrection;
      postData.time_zone = details.time_zone;
    }
    axios()
      .post(submitUrl, postData)
      .then((res) => {
        if (res.data.success) {
          if (pageType === "userProfile") {
            if (BrowserUtils.isAWebview) {
              if (typeof window.AndroidBridge !== "undefined") {
                //let myVar = window.AndroidBridge.call("getAndroidVersion");
                window.AndroidBridge.call(
                  "pushUserProfileDetails",
                  JSON.stringify({
                    name: details.name,
                    relation: details.relation,
                    gender: details.gender,
                    email: details.email,
                    phone: details.phone,
                    horoscopeStyle: details.horoscopeStyle,
                    dateOfBirth: tempDate,
                    placeOfBirth: query,
                    timeOfBirth: details.timeOfBirth,
                    profileUrl: data ? data : details.profileUrl ? details.profileUrl : "",
                    lat: details.lat,
                    long: details.long,
                    country: details.country,
                  })
                );
              }
            } else {
              if (window.Moengage) {
                window.Moengage.add_unique_user_id(details.phone);
                window.Moengage.add_first_name(details.name);
                window.Moengage.add_user_name(details.name);
                window.Moengage.add_email(details.email);
                window.Moengage.add_mobile(Number(details.phone));
                window.Moengage.add_gender(details.gender);
                window.Moengage.add_user_attribute("MOBILE_NUMBER", Number(details.phone));
                window.Moengage.add_user_attribute("DATE_OF_BIRTH", tempDate);
                window.Moengage.add_user_attribute("PLACE_OF_BIRTH", query);
                window.Moengage.add_user_attribute("HOROSCOPE_STYLE", details.horoscopeStyle);
                window.Moengage.add_user_attribute("TIME_OF_BIRTH", details.timeOfBirth);
              }
            }

            localStorage.setItem("name", details.name);
            localStorage.setItem("email", details.email);
            localStorage.setItem("phone", details.phone);
            localStorage.setItem("image", data ? data : details.profileUrl ? details.profileUrl : "");
            //remove local crj if logged in
            localStorage.removeItem("userCRJ");
            localStorage.removeItem("sunsignData");
            localStorage.removeItem("moonsignData");
            localStorage.removeItem("dailyPrediciton");
            //remove local crj if logged in
          }
          window.setTimeout(() => {
            moengage("USERPROFILE_CREATED");
            if (props.location.search !== "") {
              let redirectPath = QueryString().pathname;
              if (redirectPath === "/my-account") {
                props.history.replace("/my-account");
                //window.location.href = "/my-account";
              } else if (redirectPath === "/my-wallet") {
                props.history.replace("/my-wallet");
                //window.location.href = "/my-wallet";
              } else if (redirectPath === "/") {
                props.history.replace("/");
                //window.location.href = "/";
              } else if (redirectPath && redirectPath.indexOf("/astrologer") >= 0) {
                props.history.replace(redirectPath);
                //window.location.href = redirectPath;
              } else {
                window.location.href = "/";
              }
            } else {
              //props.history.replace("/");
              window.location.href = "/";
            }
          }, 1000);
        } else {
          showError(res.data.message);
          setLoading(false);
        }
      })
      .catch((err) => {
        sentryError("USER_PROFILE_SUBMIT_DETAILS", err);
        showError("Error occured, Please try again");
        setLoading(false);
      });
  };

  const trackPageview = () => {
    /** event tracking */
    const type = "fa_screen_usr_profile";
    const payload = {
      p_screen: "home",
      p_label: "NA",
      p_content: "NA",
      p_value: 0,
      value: 0,
      currency: "INR",
      p_ast_exp: "NA",
      p_ast_rating: "NA",
      p_ast_sort: "NA",
      p_ast_rank: "NA",
      p_ast_fees: "NA",
      p_usr_gender: BrowserUtils.CurrentUser().gender,
      p_usr_age: BrowserUtils.CurrentUser().age.toString(),
      p_usr_p: BrowserUtils.codePhone(BrowserUtils.CurrentUser().phone, 1),
    };
    window.FAEventLog(type, payload);
  };

  const getFormattedTime = (date = null) => {
    let formattedTime = date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    let time = formattedTime.split(":");
    if (time[0] < 10) {
      time[0] = "0" + time[0];
      formattedTime = time.join(":");
    }

    return formattedTime.toUpperCase();
  };

  const updateData = (data = null) => {
    let defaultDate = new Date();
    //defaultDate.setFullYear(2011);

    if (data && data.name) {
      if (!data.email && props.location.pathname === "/userprofile") {
        showError("Please update your profile details.");
      }

      if (data.timeOfBirth) {
        let time = data.timeOfBirth.split(" ");
        defaultDate.setHours(
          time[1] === "PM" && time[0].split(":")[0] !== "12"
            ? parseInt(time[0].split(":")[0]) + 12
            : time[1] === "AM" && time[0].split(":")[0] === "12"
              ? 0
              : time[0].split(":")[0]
        );
        defaultDate.setMinutes(time[0].split(":")[1]);
        setTime(defaultDate);
      }
      if (data.dateOfBirth) {
        const a = data.dateOfBirth;
        setDate(a);
        let dob = data.dateOfBirth.split("/");
        data.dateOfBirth = dob[1] + "/" + dob[0] + "/" + dob[2];
      } else {
        setDate(Moment(defaultDate).format("DD/MM/YYYY"));
      }
      const newDetails = {
        name: data.name,
        relation: data.relation,
        gender: data.gender,
        email: data.email,
        phone: data.phone,
        horoscopeStyle: data.horoscopeStyle,
        dateOfBirth: data.dateOfBirth ? data.dateOfBirth : Moment(defaultDate).format("MM/DD/YYYY"),
        placeOfBirth: data.placeOfBirth,
        timeOfBirth: data.timeOfBirth ? data.timeOfBirth : getFormattedTime(defaultDate),
        profileUrl: data.profileUrl,
        //lat: data.lat,
        //long: data.lon,
        country: data.country,
      }

      if (data?.lat || data?.lon) {
        newDetails.lat = data.lat;
        newDetails.long = data.lon;
      }

      if (data?.lat_dir) {
        newDetails.lat_deg = data.lat_deg;
        newDetails.lat_min = data.lat_min;
        newDetails.lat_dir = data.lat_dir;
        newDetails.long_deg = data.long_deg;
        newDetails.long_min = data.long_min;
        newDetails.long_dir = data.long_dir;
      }
      setDetails(newDetails);
      setQuery((data?.lat || data?.lat_dir) ? data.placeOfBirth : null);
    } else {
      //setTime(defaultDate); // no default time
      setDate(Moment(defaultDate).format("DD/MM/YYYY"));
      if (data && data.phone) {
        setDetails({
          ...details,
          phone: data.phone,
          dateOfBirth: null, //Moment(defaultDate).format("MM/DD/YYYY"),
          timeOfBirth: null, //getFormattedTime(defaultDate),
        });
      } else {
        setDetails({
          ...details,
          dateOfBirth: null, //Moment(defaultDate).format("MM/DD/YYYY"),
          timeOfBirth: null, //getFormattedTime(defaultDate),
        });
      }
    }
  };

  const resetPlace = () => {
    setDetails({
      ...details,
      lat: "",
      long: "",
      country: "",
    });
  };

  const onPlacesChange = (e) => {
    setQuery(e.target.value);
    resetPlace();
    if (counter === 1 && placesScriptLoaded) {
      let autoComplete = new window.clickastro.places.Autocomplete(document.getElementById("placeInput"), {
        types: ["(cities)"],
      });

      autoComplete.addListener("place_changed", function () {
        setQuery(document.getElementById("placeInput").value);
        let place = this.getPlace();
        let countryname = "";
        for (let i = 0; i < place.address_components.length; i++) {
          if (place.address_components[i].types[0].indexOf("country") === 0) {
            countryname = place.address_components[i].long_name;
          }
        }
        let oldDetails = details;
        if (oldDetails.hasOwnProperty('lat_deg')) {
          delete oldDetails['lat_deg'];
          delete oldDetails['lat_min'];
          delete oldDetails['lat_dir'];
          delete oldDetails['long_deg'];
          delete oldDetails['long_min'];
          delete oldDetails['long_dir'];
        }
        if (oldDetails.hasOwnProperty('timeCorrectionValue')) {
          delete oldDetails['timeCorrectionValue'];
          delete oldDetails['timeCorrection'];
          delete oldDetails['time_zone'];
        }
        setDetails({
          ...oldDetails,
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          country: countryname,
        });
      });
    }
    setCounter(counter + 1);
  };

  const handleBackButton = () => {
    if (localStorage.getItem("email") && localStorage.getItem("email") !== "") {
      if (BrowserUtils.hasUserProfile() || (props.history.length > 1 && QueryString().redirect === undefined)) {
        props.history.goBack();
      } else {
        showError("Please update your profile details");
      }
    } else {
      window.location.href = "/";
    }
  };

  useEffect(() => {
    if (
      !localStorage.getItem("btkn") ||
      localStorage.getItem("btkn") === "" ||
      localStorage.getItem("btkn") === "undefined" ||
      !localStorage.getItem("utkn") ||
      localStorage.getItem("utkn") === "" ||
      localStorage.getItem("utkn") === "undefined"
    ) {
      window.location.href = "/login?pathname=" + props.location.pathname;
    } else {
      let fetchDetailsUrl = "";
      if (props.location.pathname === "/userprofile") {
        setSubmitURL("/profile/user/edit");
        setPageType("userProfile");
        fetchDetailsUrl = "/profile/user";
        moengage("USERPROFILE_PAGE_VIEWED");
        moengage("fa_screen_usr_profile");
      } else if (props.location.pathname === "/childprofile/add") {
        setSubmitURL("/profile/add");
        setPageType("childProfile");
        setLoading(false);
        fetchDetailsUrl = "";
      } else if (props.location.pathname && props.location.pathname.indexOf("/edit-page") >= 0) {
        setSubmitURL("/profile/edit/" + props.match.params.id);
        setPageType("childProfile");
        fetchDetailsUrl = "/profile/" + props.match.params.id;
      } else {
        window.location.href = "/familyuserprofiles";
      }

      if (fetchDetailsUrl !== "") {
        if (props.location.data) {
          updateData(props.location.data);
          setLoading(false);
        } else {
          axios()
            .post(fetchDetailsUrl)
            .then((res) => {
              if (res.data.data.success) {
                updateData(res.data.data.user);
              } else {
                showError(res.data.message);
              }
              setLoading(false);
            })
            .catch((err) => {
              sentryError("USER_PROFILE_DETAILS", err);
              showError("Error occured, Please try again");
              setLoading(false);
            });
        }
      } else {
        updateData();
      }
    }
    loadScript(`https://placesapis.clickastro.com/capac/api/?key=${process.env.REACT_APP_GOOGLE_PLACES_API_KEY}`, () =>
      setPlacesScriptLoaded(true)
    );
    trackPageview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="orangeBg">
      <HelmetComponent
        title={
          (props.location.pathname === "/userprofile"
            ? "User Profile Edit"
            : props.location.pathname === "/childprofile/add"
              ? "Add Child Profile"
              : "Edit Child Profile") + " at Findastro"
        }
        url={"https://www.findastro.com" + props.location.pathname}
        description={
          (props.location.pathname === "/userprofile"
            ? "User Profile Edit"
            : props.location.pathname === "/childprofile/add"
              ? "Add Child Profile"
              : "Edit Child Profile") + " at Findastro-Connect to your Favorite Astrologer at Findastro"
        }
      />
      {isLoading ? (
        <div className="circle-loading circle-loading-20px">
          <CircularProgress />
        </div>
      ) : (
        <></>
      )}
      <div id="parentDiv">
        <Box className="userProfileTopArea">
          <ArrowBackIcon id="userProfileArrowIcon" onClick={handleBackButton} />
          <div className="userProfileChildTopArea">
            <div style={{ paddingTop: 6, fontSize: "1.2rem", color: "#fff" }}>User profile</div>
          </div>
        </Box>
        <div id="whiteBg">
          <div style={{ height: 36 }}></div>
          {/* <div id="userProfileImageBorder"></div>
          <Avatar alt="profile image" id="userProfileImage" src={details.profileUrl ? details.profileUrl : ""}>
            {tempName ? tempName[0] : null}
          </Avatar>
          <Camera id="camera" onClick={onCamera} />
          <p id="userProfileNameText2"></p> */}
          <form id="userProfileFormDiv" autoComplete="off">
            <TextField
              autoComplete="new-password"
              id="bgImageUpload"
              type="file"
              accept="image/*"
              onChange={onInputEdit}
              ref={hiddenFileInput}
              style={{ display: "none" }}
            />
            <label htmlFor="nameInput" id="nameLabel">
              Name
            </label>
            <TextField
              autoComplete="name"
              id="nameInput"
              value={details.name ? details.name : ""}
              className="formInputs"
              variant="outlined"
              label="Name"
              placeholder="Enter your name"
              onChange={onInputEdit}
            />
            {pageType === "childProfile" ? (
              <>
                <label htmlFor="relationInput" id="relationLabel">
                  Relationship
                </label>
                <TextField
                  autoComplete="new-password"
                  id="relationInput"
                  value={details.relation ? details.relation : ""}
                  className="formInputs"
                  variant="outlined"
                  label="Relashionship"
                  placeholder="Enter your relationship"
                  onChange={onInputEdit}
                />
                <label htmlFor="mobInput" id="mobLabel">
                  Mobile Number
                </label>
                <TextField
                  autoComplete="off"
                  id="mobInput"
                  value={details.phone ? details.phone : ""}
                  className="formInputs"
                  variant="outlined"
                  label="Mobile number"
                  placeholder="Enter your mobile number"
                  type="text"
                  inputProps={{ maxLength: 10 }}
                  onKeyDown={onNumValidate}
                  onChange={onInputEdit}
                />
              </>
            ) : (
              <></>
            )}

            <FormControl variant="outlined" className="formInputs">
              <InputLabel id="demo-simple-select-outlined-label">Gender</InputLabel>
              <Select
                value={details.gender ? details.gender : ""}
                onChange={(e, value) => setDetails({ ...details, gender: e.target.value })}
                label="Gender"
                id="genderInput">
                {userProfileData.gender.map((gender, index) => (
                  <MenuItem value={gender}>{gender}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <label htmlFor="genderInput" id="genderLabel">
              Gender
            </label>
            <Autocomplete
              className="formInputs"
              autoSelect={true}
              value={details.gender ? details.gender : null}
              onChange={(e, value) => setDetails({...details, gender: value})}
              id="genderInput"
              options={userProfileData.gender}
              renderInput={(params) => <TextField {...params} variant="outlined" label="Gender" placeholder="Gender" />}
            /> */}
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <label htmlFor="dobInput" id="dobLabel">
                Date of Birth
              </label>
              <KeyboardDatePicker
                margin="normal"
                id="dobInput"
                format="dd/MM/yyyy"
                disableFuture={true}
                className="formInputs"
                placeholder="dd/mm/yyyy"
                views={["year", "month", "date"]}
                inputVariant="outlined"
                openTo="year"
                label="Date of birth"
                minDate={new Date("01/01/" + (new Date().getFullYear() - 100))}
                maxDate={new Date()}
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                value={details.dateOfBirth ? details.dateOfBirth : null}
                onChange={onDateEdit}
                open={DOBOpen}
                onClick={() => {
                  setDOBOpen(true);
                }}
                onClose={() => {
                  setDOBOpen(false);
                }}
              />
              <label htmlFor="timeInput" id="timeLabel">
                Time of Birth
              </label>
              <KeyboardTimePicker
                margin="normal"
                id="timeInput"
                inputVariant="outlined"
                label="Time of birth"
                className="formInputs"
                placeholder="hh:mm"
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                open={TOBOpen}
                onClick={() => {
                  setTOBOpen(true);
                }}
                onClose={() => {
                  setTOBOpen(false);
                }}
                value={time ? time : null}
                onChange={onTimeEdit}
                keyboardIcon={<AccessTimeIcon />}
              />
            </MuiPickersUtilsProvider>
            <label htmlFor="placeInput" id="placeLabel">
              Place of Birth
            </label>
            <TextField
              autoComplete="street-address"
              id="placeInput"
              onFocus={(e) => window.scrollTo(0, 1000)}
              value={query ? query : ""}
              className="formInputs"
              variant="outlined"
              label="Place of Birth"
              placeholder="Enter your location"
              onChange={onPlacesChange}
            />
            {/* <label htmlFor="horoInput" id="horoLabel">
              Horoscope Style
            </label>
            <Autocomplete
              className="formInputs"
              value={details.horoscopeStyle ? details.horoscopeStyle : null}
              onChange={(e, value) => setDetails({...details, horoscopeStyle: value})}
              id="horoInput"
              options={userProfileData.horoscope}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  readonly
                  label="Horoscope Style"
                  placeholder="Horoscope Style"
                />
              )}
            /> */}
            <FormControl variant="outlined" className="formInputs">
              <InputLabel id="demo-simple-select-outlined-label">Horoscope Style</InputLabel>
              <Select
                value={details.horoscopeStyle ? details.horoscopeStyle : ""}
                onChange={(e, value) => setDetails({ ...details, horoscopeStyle: e.target.value })}
                id="horoInput"
                label="Horoscope Style">
                {userProfileData.horoscope.map((horoscope, index) => (
                  <MenuItem value={horoscope}>{horoscope}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <label htmlFor="emailInput" id="emailLabel">
              Email
            </label>
            <TextField
              autoComplete="one-time-code"
              id="emailInput"
              value={details.email ? details.email : ""}
              className="formInputs"
              variant="outlined"
              label="Email"
              placeholder="Enter your email"
              onChange={onInputEdit}
            />
            {isInRegisterFlow === true ? (
              <>
                <Button
                  id="userProfileSaveButton"
                  variant="contained"
                  onClick={onSubmitUserDetails}
                >
                  Save profile
                </Button>
              </>
            ) : (
              <Button id="userProfileSaveButton" variant="contained" onClick={onSubmitUserDetails}>
                Save profile
              </Button>
            )}
            <input
              autoComplete="new-password"
              style={{ display: "none" }}
              id="fake-hidden-input-to-stop-google-address-lookup"></input>
          </form>
          <div style={{ padding: "24px", color: "#929292" }}>
            We will use this birth details to give you daily horoscope predictions. Your data will always be secure.
          </div>
          <div style={{ height: 72 }}></div>
        </div>
        <Snackbar
          vertical="top"
          horizontal="right"
          message={snackBar.message}
          closeError={closeError}
          open={snackBar.open}></Snackbar>
      </div>
    </div>
  );
};

export default UserProfile;
